/**
 * Copyright (c) 2010-2020 California CAD Solutions, Inc. Licensed subject
 * to an End-User License Agreement included in a separate file named EULA.txt
 * that is distributed with this file.
 */
import { makeEnvironmentProviders, ModuleWithProviders, NgModule } from '@angular/core';
import { NGXS_PLUGINS, NgxsModule, provideStates, withNgxsPlugin } from '@ngxs/store';
import {NGXS_SNAPSHOT_PLUGIN_OPTIONS, NgxsSnapshotPlugin} from './ngxs-snapshot.plugin';
import {NgxsSnapshotPluginOptions} from './ngxs-snapshot.model';
import {NgxsSnapshotState} from './ngxs-snapshot.state';

export function withNgxsSnapshotPlugin(options: NgxsSnapshotPluginOptions) {
    return makeEnvironmentProviders([
        provideStates([NgxsSnapshotState]),
        withNgxsPlugin(NgxsSnapshotPlugin),
        {
            provide: NGXS_SNAPSHOT_PLUGIN_OPTIONS,
            useValue: options
        }
    ])
}
@NgModule({
    imports: [ NgxsModule.forFeature([NgxsSnapshotState])]
})
export class NgxsSnapshotPluginModule {
    static forRoot(config?: NgxsSnapshotPluginOptions): ModuleWithProviders<NgxsSnapshotPluginModule> {
        return {
            ngModule: NgxsSnapshotPluginModule,
            providers: [{
                provide: NGXS_PLUGINS,
                useClass: NgxsSnapshotPlugin,
                multi: true
            }, {
                provide: NGXS_SNAPSHOT_PLUGIN_OPTIONS,
                useValue: config
            }]
        };
    }
}
